import React, { useState, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Login } from '@/components/auth'
import { ROUTES, STORAGE_KEYS } from '@/constants'
import { routeToRedirectUrl } from '@/utils'

export const LoginPage = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const redirectUrl = useMemo(() => {
    const searchParams = new URLSearchParams(location.search)
    const hasRedirectUrl = searchParams.has(STORAGE_KEYS.REDIRECT_URL)
    if (hasRedirectUrl) {
      return searchParams.get(STORAGE_KEYS.REDIRECT_URL)
    }
    return null
  }, [location])

  const onSuccess = async e => {
    if (redirectUrl) routeToRedirectUrl(redirectUrl)
    else navigate(ROUTES.HOME)
  }

  const onAccountRecovery = () => {
    navigate(ROUTES.ACCOUNT_RECOVERY)
  }

  return (
    <Login
      redirectUrl={redirectUrl}
      onSuccess={onSuccess}
      onAccountRecovery={onAccountRecovery}
    />
  )
}
